import { render, staticRenderFns } from "./ValentinesDay_drinkSection.vue?vue&type=template&id=49b1a19e&scoped=true"
import script from "./ValentinesDay_drinkSection.vue?vue&type=script&lang=ts"
export * from "./ValentinesDay_drinkSection.vue?vue&type=script&lang=ts"
import style0 from "./ValentinesDay_drinkSection.vue?vue&type=style&index=0&id=49b1a19e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b1a19e",
  null
  
)

export default component.exports